import { render, staticRenderFns } from "./返済原資Cell.vue?vue&type=template&id=dbf20a98&"
import script from "./返済原資Cell.ts?vue&type=script&lang=ts&"
export * from "./返済原資Cell.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports